// extracted by mini-css-extract-plugin
export default {"container":"PersonaLinkSelector_container__oMwRu"};